import { ReactComponent as CloseIcon } from '@app/assets/x.svg';
import { Dialog } from '@mui/material';
import clsx from 'clsx';
import { useState } from 'react';

type Props = {
    onClose?: () => void;
};

export default function ChampionSneakPeekDialog({ onClose }: Props) {
    const [isOpen, setIsOpen] = useState(true);
    const onCloseDialog = () => {
        setIsOpen(false);
        onClose?.();
    };
    return (
        <Dialog open={isOpen} maxWidth={false} classes={DIALOG_CLASSES}>
            <CloseIcon
                onClick={onCloseDialog}
                className="absolute right-15 top-15 inline-block cursor-pointer text-gray-600"
            />
            <div className="h-full w-full overflow-auto px-20 sm:px-40">
                <section className="mb-20 border-b border-b-gray-300 pb-20 dark:border-b-gray-800 sm:mt-5">
                    <div className="mb-18 text-center sm:mb-27">
                        <img
                            className="inline-block w-150 md:w-210"
                            src="/images/champion-logo@3x.png"
                            alt="champion-logo"
                        />
                    </div>
                    <div className="flex flex-col space-y-6">
                        <HeadHeading text="Sorry, this is an upcoming novel that is not yet ready for release to the general public." />
                        <HeadParagraph text="Only Champions are allowed a sneak peek! To become a Champion, sign up for a Wuxiaworld account and/or then subscribe!" />
                    </div>
                </section>
                <section>
                    <div className="mb-20 flex flex-col space-y-6">
                        <BodyHeading text="What does it mean to be a Champion?" />
                        <BodyParagraph text="Champions are monthly subscribers who help fund this site and keep it running! Champions get an ad-free account and other perks, such as special flairs and sneak peeks to upcoming novels." />
                    </div>
                    <div className="mb-20 flex flex-col space-y-6">
                        <BodyHeading text="Champions are monthly subscribers who help fund this site and keep it running! Champions get an ad-free account and other perks, such as special flairs and sneak peeks to upcoming novels." />
                        <BodyParagraph text="Upcoming novels are novels with fewer than 50 translated chapters that are in the queue to join Wuxiaworld and be accessible to everyone, but aren't quite 'ready' yet. This could be for a number of reasons, such as the release rate not yet being steady, the translator wanting to launch with a larger pool of chapters, or minor licensing issues which we believed will soon be resolved (for example, an oral agreement with rights holders that is pending final signing due to lawyers wrangling over language). Whatever the case may be, for 'upcoming novels' translators have already begun translating but are not yet ready to take the chapters 'prime time'. 'Upcoming novels' is a way for us to further reward and thank our loyal Champion subscribers by giving them sneak peeks at this." />
                    </div>
                    <div className="mb-20 flex flex-col space-y-6">
                        <BodyHeading text="How long will it be before an 'upcoming novel' is ready for the main site?" />
                        <BodyParagraph text="Honestly, it's hard to say. In general, once an upcoming novel has at least 50 chapters, we should be ready to go unless the issues are of a legal/licensing nature. We want to go as much as you do! Just wait for the announcements." />
                    </div>
                    <div className="flex flex-col space-y-6">
                        <BodyHeading text="How quickly will 'upcoming novels' be updated?" />
                        <BodyParagraph text="No regularity or rhythm whatsoever. These aren't meant to be regularly followed novels, just extended and tasty teasers of exciting projects to come. If you really like certain 'upcoming novels', make sure you let us know in the comments of those chapters and practice your old-school F5 skills!" />
                    </div>
                </section>
            </div>
        </Dialog>
    );
}

const DIALOG_CLASSES = {
    root: 'p-8 sm:px-30 md:px-0',
    paper: clsx([
        'm-0',
        'pt-36 pb-20 sm:py-40',
        'max-h-[unset]',
        'h-[calc(100%-16px)] sm:h-auto',
        'sm:max-w-[840px] md:max-w-[898px]',
        'bg-white dark:bg-black',
    ]),
};

type TypoProps = {
    text: string;
};
const HeadHeading = ({ text }: TypoProps) => {
    return <h2 className="font-set-sb16 text-gray-t1 sm:font-set-sb18">{text}</h2>;
};
const HeadParagraph = ({ text }: TypoProps) => {
    return <p className="font-set-r14 text-gray-t1">{text}</p>;
};
const BodyHeading = ({ text }: TypoProps) => {
    return <h3 className="font-set-b13 text-gray-t1 sm:font-set-b14">{text}</h3>;
};
const BodyParagraph = ({ text }: TypoProps) => {
    return <p className="font-set-r13 text-gray-t3 sm:font-set-r14">{text}</p>;
};
